<template>
  <div>
    <ManagementPage :pageName="$t('External') + ' / ' + $tc('Map', 2)">
      <template v-slot:left>
        <TableView
          :selectedObjectID="selectedMap ? selectedMap.id : null"
          @open-create-map-form="isThirdPartyDialogOpen = true"
          @clear-selected-item="selectedMap = null"
        />
      </template>
      <template v-slot:right>
        <Map
          :selectedMap="selectedMap"
          @clear-selected-item="selectedMap = null"
        />
        <ThirdPartyDialog
          :isOpen="isThirdPartyDialogOpen"
          @createMap="
            selectedMap = {};
            isThirdPartyDialogOpen = false;
          "
          @cancelMap="isThirdPartyDialogOpen = false"
        >
        </ThirdPartyDialog>
      </template>
    </ManagementPage>
    <dialog-choice :isOpen="discardChangesDialogIsOpen" :title="$t('DiscardChanges')"
              :content="$t('ClusterCreationConfirmation')" :mainActionLabel="$t('Confirm')" @mainAction="confirmDiscardChanges"
              :secondaryActionLabel="$t('Cancel')" @secondaryAction="discardChangesDialogIsOpen = false" icon="mdi-delete"
              iconColor="var(--app-primary-base)" />
  </div>
</template>

<script>
import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
import TableView from "@/newComponents/Maps/TableView.vue";
import { bus } from "@/main.js";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import Map from "@/newComponents/Maps/Map.vue";
import ThirdPartyDialog from "@/newComponents/Maps/ThirdPartyDialog.vue";
import DialogChoice from "@/newComponents/_Molecules/DialogChoice.vue";


export default {
  name: "MapsView",

  props: ["pageName", "menu"],

  components: {
    ManagementPage,
    TableView,
    Map,
    ThirdPartyDialog,
    DialogChoice,
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      search: "",
      selectedMap: null,
      isThirdPartyDialogOpen: false,
      userIsCreatingOrEditingData: false,
      discardChangesDialogIsOpen: false,
      tempData: null,
    };
  },

  mounted() {
    bus.$on("toggle-create-edit-flag", () => this.userIsCreatingOrEditingData = !this.userIsCreatingOrEditingData)
    bus.$on('on-row-click', data => {
      if(this.userIsCreatingOrEditingData){
        this.tempData = _.cloneDeep(data);
        this.discardChangesDialogIsOpen = true;
      } else {
          this.selectedMap = !!this.selectedMap && data.id === this.selectedMap.id ? null : _.cloneDeep(data);
        }
    });
  },

  destroyed() {
    bus.$off('on-row-click');
    bus.$off("toggle-create-edit-flag");
  },

  methods: {
    confirmDiscardChanges() {
      this.discardChangesDialogIsOpen = false;
      this.selectedMap = !!this.selectedMap && this.tempData.id === this.selectedMap.id ? null : _.cloneDeep(this.tempData);
      this.tempData = null;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/MapsView.vue